import { useCallback } from "react";

import type { PlanStock_StockManagementQuery } from "@/lib/gql/__generated__/graphql";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import { useCreatePlanStockFormModel } from "./usecase/use-create-form-model";

// eslint-disable-next-line import/no-restricted-paths
import type { ApolloQueryResult } from "@apollo/client";

type Props = {
	serverModel: PlanStock_StockManagementQuery;
	onFetchPlanStock: ({
		input: { startDt, endDt },
	}: {
		input: {
			startDt: string;
			endDt: string;
		};
	}) => Promise<ApolloQueryResult<PlanStock_StockManagementQuery | undefined>>;
};

export const useInitialized = ({ serverModel, onFetchPlanStock }: Props) => {
	const { isDirty, isValid, onUpdatePlanStock, onReInitialize, planStockDiffStore } = useCreatePlanStockFormModel({
		serverModel,
	});

	const onRefetch = useCallback(
		async (input: { startDt: string; endDt: string }) => {
			const { data: serverModel, error, errors } = await onFetchPlanStock({ input });

			if (error || errors) {
				notifyUserEventInfo({
					variant: "error",
					title: "プラン在庫の取得に失敗しました",
					description: "時間を置いて再度お試しください",
				});
			} else if (serverModel) {
				onReInitialize();
			}
		},
		[onFetchPlanStock, onReInitialize],
	);

	return {
		isDirty,
		isValid,
		serverModel,
		onUpdatePlanStock,
		onReInitialize,
		planStockDiffStore,
		onRefetch,
	};
};
